module.exports = __webpack_public_path__ + "img/logo-light.cb398c61.svg";